import React from 'react';
import autoBind from 'react-autobind';
import Toggle from 'material-ui/Toggle';

const style = {
  display: 'inline-block',
  width: ''
};

export default class FieldToggle extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  handleChange(event) {
    const { name, value } = this.props;
    this.props.onChange({ name, value: !value });
  }
  render() {
    const _props = { ...this.props };
    _props.onChange = this.handleChange;
    _props.onToggle = this.handleChange;
    _props.style = { ...style, ...this.props.style };
    _props.labelPosition = this.props.labelPosition || 'right';
    _props.toggled = this.props.value;
    _props.inputStyle = { marginRight: '8px', ...this.props.inputStyle };
    const labelColor = this.props.value ? { color: '#000' } : { color: '#999' };
    _props.labelStyle = {
      ...labelColor,
      ...this.props.labelStyle
    };
    return <Toggle {..._props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/FieldToggle/index.jsx